// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__3PUwj","tab":"TabNav_tab__2_G8_","link":"TabNav_link__1JPaL","selectedLink":"TabNav_selectedLink__1XaGc","disabled":"TabNav_disabled__1iZfW"};